"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidePanelNavigation = void 0;
const react_1 = __importStar(require("react"));
const Form_1 = __importDefault(require("../../../components/form/Form"));
const components_1 = require("../../../components");
const hooks_1 = require("../../../util/hooks");
const SidePanelNavigationBlock_1 = require("./SidePanelNavigationBlock");
const SidePanelNavigation = function (props) {
    const { headerText, searchText, itemList, getter, defaultOnClick, autoFocus, } = props;
    const [search, setSearch] = (0, react_1.useState)('');
    const [data, setDat, reload] = (0, hooks_1.useQData)(async () => {
        const tData = [];
        for (const item of itemList) {
            tData.push({
                tree: await getter(item.key),
                sel: item,
            });
        }
        return tData;
    });
    const options = [];
    options.push([
        {
            label: searchText,
            key: 'search',
            type: components_1.InputOptionType.TEXT,
            autoFocus: !!autoFocus,
        },
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "sidebar-head-block" },
            react_1.default.createElement(Form_1.default, { options: options, defaultState: {
                    search: '',
                }, onChange: (form) => {
                    setSearch(form.search);
                } })),
        react_1.default.createElement("div", { className: "sidebar-panel-scroll" }, data?.map((x, index) => {
            return (react_1.default.createElement(SidePanelNavigationBlock_1.SidePanelNavigationBlock, { key: `nav-${x.sel.key}`, data: x.tree, search: search, defaultOnClick: defaultOnClick, single: data?.length === 1, headerText: x.sel.name, icon: x.sel.icon }));
        }) || (react_1.default.createElement(components_1.Grid, { className: "glx-pt-8", flex: true, flexRow: true, hCenter: true },
            react_1.default.createElement(components_1.LDots, null))))));
};
exports.SidePanelNavigation = SidePanelNavigation;
SidePanelNavigation.defaultProps = {
    defaultOnClick: undefined,
    autoFocus: undefined,
};
